import { getStateCode } from '@/shared/lib/get-state-code';

import type { ClientProfileAddress } from '../model/client.types';

// "City, ST ZIP" — the comma sits after the city only, so a missing part leaves no stray
// punctuation behind. `state` is stored as the full name; the two-letter code is shown.
export function formatAddressLocality(address: ClientProfileAddress | null): string {
    if (!address) return '';

    const cityState = [address.city, getStateCode(address.state)].filter(
        (part) => part.trim() !== '',
    );

    return [cityState.join(', '), address.zip].filter((part) => part.trim() !== '').join(' ');
}
